import { clearTransactionType } from 'src/utils/transactionTypeFromLS';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { withdrawalStatusMap } from '../utils';
import { useMessage } from 'src/modules/messages';
import { TransactionStatus } from '../types';

interface WithdrawalRedirectType {
  status: TransactionStatus;
  isInitialWithdrawal: boolean;
  merchantId?: string;
}

export const useWithdrawalRedirect = ({ status, isInitialWithdrawal }: WithdrawalRedirectType) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const entry = withdrawalStatusMap[status];

  useEffect(() => {
    if (isInitialWithdrawal && entry) {
      openMessage({
        type: 'USER_MESSAGE',
        props: { text: t(entry.key), status: entry.status },
        saveToHistory: false
      });
    }
  }, []);

  useEffect(() => {
    if (isInitialWithdrawal) {
      clearTransactionType();
    }
  }, []);
};
